export const COMPANY = {
  name: 'Spotless AI',
  logoSrc: `${process.env.PUBLIC_URL || ''}/Spotless.png`,
  phone: '7092022700',
  website: 'www.spotless.ai',
  email: 'info@spotless.ai',
  address: 'Spotless AI, India',
};

function pad(n) {
  return String(n).padStart(2, '0');
}

export function generateInvoiceNumber() {
  const now = new Date();
  const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
  const suffix = String(Math.floor(Math.random() * 9000) + 1000);
  return `${stamp}${suffix}`;
}

export function formatDisplayDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatMoney(amount, currency = 'INR') {
  const value = Number(amount);
  if (Number.isNaN(value)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function createEmptyLineItem() {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    description: '',
    quantity: 1,
    unitPrice: 0,
  };
}

export function createDefaultInvoiceModel() {
  const today = new Date();
  const due = new Date(today);
  due.setDate(due.getDate() + 30);
  const invoiceNumber = generateInvoiceNumber();

  return {
    invoiceNumber,
    reference: invoiceNumber,
    issueDate: today.toISOString().slice(0, 10),
    dueDate: due.toISOString().slice(0, 10),
    billToName: '',
    billToAddress: '',
    lineItems: [
      { ...createEmptyLineItem(), description: 'Analysis & research', quantity: 1, unitPrice: 500 },
      { ...createEmptyLineItem(), description: 'Web design & planning', quantity: 1, unitPrice: 2000 },
    ],
    gstPercent: 18,
    currency: 'INR',
    issuerSignature: '',
    companyPhone: COMPANY.phone,
    companyWebsite: COMPANY.website,
    companyEmail: COMPANY.email,
    companyAddress: COMPANY.address,
  };
}

export function lineAmount(item) {
  const qty = Number(item.quantity);
  const price = Number(item.unitPrice);
  if (Number.isNaN(qty) || Number.isNaN(price)) return 0;
  return qty * price;
}

export function computeInvoiceTotals(model) {
  const subtotal = (model.lineItems || []).reduce((sum, item) => sum + lineAmount(item), 0);
  const gstPercent = Number(model.gstPercent) || 0;
  const taxAmount = (subtotal * gstPercent) / 100;
  const total = subtotal + taxAmount;
  return { subtotal, taxAmount, total, gstPercent };
}
